// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2331ff07","977":"0b019f26"}[chunkId] + ".chunk.js";
};